module.exports = __webpack_public_path__ + "img/LUB00324.2f00b4a4.svg";